import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { VehicleRepairStoreService } from '../repairer-downtime.service';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { CardBodyComponent, CardComponent, CardHeaderComponent, SmartTableModule, SpinnerModule } from '@coreui/angular-pro';
import * as moment from 'moment';
import 'moment-duration-format';
import { SecondToDaysHoursMinutes } from '../second-to-days-hours-minutes.pipe';

@Component({
  selector: 'app-downtime-repairer-detail',
  standalone: true,
  imports: [CommonModule, 
    CardComponent,
    CardBodyComponent,
    CardHeaderComponent,
    SmartTableModule, SpinnerModule, RouterLink,
    SecondToDaysHoursMinutes
  ],
  templateUrl: './downtime-repairer-detail.component.html',
  styleUrl: './downtime-repairer-detail.component.scss',
})
export class DowntimeRepairerDetailComponent implements OnInit, OnDestroy {
  VehicleRepairDataDetailSubscription!: Subscription;
  loadingSubscription$!: Subscription;
  vehicleRepairData: any[] = [];
  repairerName = '';
 
  isLoading = false;

  constructor(
    private VehicleRepairStoreService: VehicleRepairStoreService,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private _location: Location
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((res) => {
      console.log(res['repairerId']);

      const detailData = this.VehicleRepairStoreService.getRepairerDetailNew(res['repairerId']);
      if (detailData) {
        this.repairerName = detailData.name;
        this.vehicleRepairData = detailData['vehicle_times'];
        this.cd.detectChanges();
      }
    });

    this.loadingSubscription$ =  this.VehicleRepairStoreService.isLoading.subscribe(data => {
      console.log('this.loadingSubscription$: data: ', data);
      this.isLoading = data;
    });


    // this.isLoading = true;

    // this.VehicleRepairDataDetailSubscription =
    //   this.VehicleRepairStoreService.VehicleRepairDataDetailObservable.subscribe(
    //     (data: any) => {
    //       debugger
    //       this.isLoading = false;
    //       if (data) {
    //         debugger;
           
    //         this.repairerName = data.name;
    //         this.vehicleRepairData = data['vehicle_times'];
    //         this.cd.detectChanges();
    //       }
    //     }
    //   );
  }

  backClicked() {
    this._location.back();
  }

  ngOnDestroy() {
    this.isLoading = false;
    // this.VehicleRepairDataDetailSubscription.unsubscribe();
    // this.VehicleRepairStoreService.nullifySubject();
  }
}
